import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { media_url } from '../../hooks/useBlog';
import { FaSearch, FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import './NewsSidebar.scss';

const NewsSidebar = () => {
  const { posts } = useSelector((state) => state.blog);
  const recentPosts = posts ? posts.slice(0, 5) : [];

  return (
    <div className="news-sidebar">
      {/* Search */}
      <div className="news-sidebar-widget">
        <h4 className="widget-title">Buscar</h4>
        <div className="search-box">
          <input type="text" placeholder="Buscar noticias..." />
          <button><FaSearch /></button>
        </div>
      </div>

      {/* Trending */}
      <div className="news-sidebar-widget">
        <h4 className="widget-title">Tendencias</h4>
        <div className="trending-list">
          {recentPosts.map((post, index) => (
            <Link
              key={post.id}
              to={`/post/${post.slug || post.id}?id=${post.id}`}
              className="trending-item"
            >
              <span className="trending-number">{index + 1}</span>
              <div className="trending-content">
                <h5>{post.title}</h5>
                <span className="trending-date">
                  {new Date(post.created).toLocaleDateString('es-ES', {
                    day: 'numeric',
                    month: 'short'
                  })}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Social */}
      <div className="news-sidebar-widget">
        <h4 className="widget-title">Síguenos</h4>
        <div className="social-links">
          <a href="#" className="social-btn facebook"><FaFacebookF /></a>
          <a href="#" className="social-btn twitter"><FaTwitter /></a>
          <a href="#" className="social-btn instagram"><FaInstagram /></a>
          <a href="#" className="social-btn youtube"><FaYoutube /></a>
        </div>
      </div>
    </div>
  );
};

export default NewsSidebar;
